import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
import Icon from './icon';

const ESC = 27;

export const STATIC_CLOSE_BUTTON_CLASS = 'modal-close-button';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: !!props.visible };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.hasOwnProperty('visible') && props.visible !== this.state.visible) {
      this.setState({
        visible: props.visible
      });
    }
  }

  componentDidMount() {
    this.handleComponentUpdate(this.props, this.state);
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
    if (this.state.visible) {
      this.props.onHide();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleComponentUpdate(prevProps, prevState);
  }

  handleComponentUpdate(prevProps, prevState) {
    if (prevState.visible !== this.state.visible) {
      if (this.state.visible) {
        this.props.onShow();
      } else {
        this.props.onHide();
      }
      this.setBodyOverflowVisible(!this.state.visible);
    }
  }

  setBodyOverflowVisible(visible) {
    if (!visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  handleOverlayClick(e) {
    const { preventOverlayClose } = this.props;

    if (
      !preventOverlayClose &&
      e.target === findDOMNode(this.refs.overlay) &&
      this.props.closable
    ) {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    }
  }

  toggle() {
    var visible = !this.state.visible;
    this.setState({
      visible: visible
    });
  }

  show() {
    this.setState({ visible: true });
  }

  hide() {
    this.setState({ visible: false });
  }

  onKeyDown = e => {
    const { onConfirm } = this.props;
    const { visible } = this.state;

    if (!visible) {
      return;
    }

    const keyCode = e.keyCode;
    if (keyCode === ESC) {
      this.hide();
    } else if (keyCode === 13 && onConfirm && typeof onConfirm === 'function') {
      onConfirm();
      this.hide();
    }
  };

  render() {
    var modal = null,
      close = null;
    if (this.props.closable) {
      close = (
        <span
          className={classnames('close', this.props.closeClassName, STATIC_CLOSE_BUTTON_CLASS)}
          onClick={this.hide.bind(this)}
        >
          <Icon name="close" className="close-icon" />
        </span>
      );
    }
    if (this.state.visible) {
      var overlayClassName = classnames('overlay', { hidden: !this.state.visible });
      var modalClassname = classnames('modal', this.props.className);
      modal = (
        <div
          className={overlayClassName}
          ref="overlay"
          onClick={this.handleOverlayClick.bind(this)}
        >
          <div className={modalClassname}>
            {close}
            {this.props.children}
          </div>
        </div>
      );
    }

    return modal;
  }
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  visible: PropTypes.bool,
  closable: PropTypes.bool,
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  onConfirm: PropTypes.func,
  preventOverlayClose: PropTypes.bool,
  closeClassName: PropTypes.string
};

Modal.defaultProps = {
  onShow: () => {},
  onHide: () => {},
  closable: true,
  preventOverlayClose: false
};

Modal.displayName = 'Modal';

export default Modal;
